import { useController } from "react-hook-form";
import { useCombinedRefs } from "../hooks/useCombinedRefs.js";
import { useFormManager } from "./FormManagerProvider.js";
import { isPathInSchemaRequired } from "./_internal/isPathInSchemaRequired.js";
const useManagedProps = ({ schemaPathRequirementMap: schemaPathRequirementMapProp, controlProps, ...props }, ref)=>{
    const { onChange, onBlur, required } = props;
    const { field, fieldState, formState } = useController(controlProps);
    const { schemaPathRequirementMap: schemaPathRequirementMapFromContext } = useFormManager() ?? {};
    const combinedRefs = useCombinedRefs(ref, field.ref);
    const schema = schemaPathRequirementMapProp ?? schemaPathRequirementMapFromContext;
    const { name, ...fieldWithoutName } = field;
    return {
        propsWithRef: {
            status: fieldState.error ? 'error' : void 0,
            required: schema ? isPathInSchemaRequired(controlProps.name, schema) : required,
            ...props,
            ...fieldWithoutName,
            onChange: (value)=>{
                field.onChange(value);
                onChange?.(value);
            },
            onBlur: (event)=>{
                field.onBlur();
                onBlur?.(event);
            },
            ref: combinedRefs
        },
        field,
        fieldState,
        formState
    };
};
export { useManagedProps };
